import { useAtom } from "jotai";
import { ReactElement } from "react";
import { latestDateAtom } from "../../stores/mimosysStore";
import { Flex } from "@chakra-ui/react";
import dayjs from "dayjs";
import { NumericDataText } from "./NumericDataText";

function displayTodayWeekDay(): string {
  const now = dayjs();
  return `${now.format("(ddd)")}`;
}

export function AnalyzedDate(): ReactElement {
  const [latestDate] = useAtom(latestDateAtom);
  if (latestDate) {
    return (
      <Flex justifyContent="center" alignItems="baseline" fontWeight="bold">
        <NumericDataText fontSize="3xl">
          {latestDate.format("YYYY/M/D")}&nbsp;
        </NumericDataText>
        <NumericDataText fontSize="2xl">
          {latestDate.format("HH:mm:ss")}
        </NumericDataText>
      </Flex>
    );
  } else {
    return (
      <Flex
        justifyContent="center"
        alignItems="baseline"
        fontWeight="bold"
        letterSpacing={2}
      >
        <NumericDataText fontSize="3xl">
          {dayjs().format("YYYY/M/D")}
        </NumericDataText>
        <NumericDataText fontSize="2xl">
          {displayTodayWeekDay()}
        </NumericDataText>
      </Flex>
    );
  }
}
